import { ModalIdentifiers } from "@/constants";
// import { Rate } from "@/model/provider-cost";
// import { Layers } from "lucide-react";
import type { PlaceOfService, Rate } from "@/model/provider-cost";
import { Info, Layers } from "lucide-react";

const RateDetails: React.FC<{
  rateInfo: Rate;
  isBundle: boolean;
  viewCallback: (identifier: ModalIdentifiers) => void;
  costBreakdownCallback: (
    identifier: ModalIdentifiers,
    posData: PlaceOfService,
  ) => void;
  deductibleStatus: boolean;
}> = ({
  rateInfo,
  isBundle,
  viewCallback,
  costBreakdownCallback,
  deductibleStatus,
}) => {
  return (
    <>
      {/* Facility */}
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col items-start justify-start gap-1">
          {/* <h2 className="text-sm font-bold">TOTAL {billingClass} FEE</h2> */}
          <h2 className="text-sm font-bold">
            {/* TOTAL {rateInfo.facility.billingClass.toUpperCase()} FEE */}
            ESTIMATED {rateInfo.facility.billingClass.toUpperCase()} FEE
          </h2>
          {rateInfo.facility.negotiatedRate.min !== Infinity && (
            <p className="text-sm text-muted-foreground">
              {rateInfo.facility.negotiatedRate.label}
            </p>
          )}
          {/* {rateInfo.facility.estimatedRate.min !== Infinity && (
            <p className="text-sm text-muted-foreground">
              {rateInfo.facility.estimatedRate.label}
            </p>
          )} */}
        </div>
        <div className="text-right text-sm font-bold">
          {rateInfo.facility.rate}
        </div>
      </div>

      {/* Professional */}
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col items-start justify-start gap-1">
          <h2 className="text-sm font-bold">
            {/* TOTAL {rateInfo.professional.billingClass.toUpperCase()} FEE */}
            ESTIMATED {rateInfo.professional.billingClass.toUpperCase()} FEE
          </h2>
          {rateInfo.professional.negotiatedRate.min !== Infinity && (
            <p className="text-sm text-muted-foreground">
              {rateInfo.professional.negotiatedRate.label}
            </p>
          )}
          {/* {rateInfo.professional.estimatedRate.min !== Infinity && (
            <p className="text-sm text-muted-foreground">
              {rateInfo.professional.estimatedRate.label}
            </p>
          )} */}
        </div>
        <div className="text-right text-sm font-bold">
          {rateInfo.professional.rate}
        </div>
      </div>
      <hr />

      {/* Estimated Total */}
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col items-start justify-start gap-1">
          <h2 className="text-sm font-bold">
            {/* TOTAL {rateInfo.estimatedTotal.billingClass} FEE */}
            YOUR TOTAL ESTIMATED COST
          </h2>

          <p className="cursor-pointer text-sm text-muted-foreground">
            {`You have ${!deductibleStatus ? "not " : ""}met the deductible limit.`}
            <button
              className="px-2 py-0 text-primary underline"
              onClick={() => {
                // callback(ModalIdentifiers.SPEND_SUMMARY);
                viewCallback(ModalIdentifiers.SPEND_SUMMARY);
              }}
            >
              View
            </button>
          </p>

          {isBundle && (
            <p className="flex cursor-pointer items-center gap-1 text-sm text-muted-foreground">
              This estimate is for a bundle of procedures.
              <Layers size={16} className="inline-block text-blue-500" />
            </p>
          )}
        </div>

        {/* 2.1.1 Keyboard — A / 4.1.2 — A: the cost-breakdown trigger was a
            <div onClick>, so a member could not open the breakdown of what they are being
            asked to pay without a mouse. */}
        <button
          type="button"
          aria-label="View cost breakdown"
          className="flex cursor-pointer items-start justify-center rounded text-right text-lg font-bold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          onClick={() =>
            costBreakdownCallback(
              ModalIdentifiers.POS_COST_BREAKDOWN_CONTAINER,
              rateInfo,
            )
          }
        >
          <span>{rateInfo.estimatedTotal.rate}</span>
          <Info
            aria-hidden="true"
            className="ml-2 size-3 rounded-full bg-yellow-500 text-white"
          />
        </button>
      </div>
    </>
  );
};

export default RateDetails;
